import Actions from '../../odata/actionsForStringId';

const actions = new Actions('venueType', 'venueTypes', 'name');

export default actions;
